import React from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export default function RootSenseFirmwareLinks() {
  const { t } = useTranslation();
  return (
    <Box mt={1} mb={1} style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>
      <Typography>
        <Link href="https://docs.growcontrol.de/RootSense_Link_Firmware_Update_DE_EN.pdf" target="_blank" rel="noopener noreferrer">
          {t('root_sense_firmware_update_instructions')}
        </Link>
      </Typography>
      <Typography>
        <Link href="https://docs.growcontrol.de/fw1400x0015b.bin" target="_blank" rel="noopener noreferrer">
          {t('root_sense_firmware_file')}
        </Link>
      </Typography>
    </Box>
  );
}
